<template>
  <div class="index-newbrand-warp" ref="scroll"  @scroll="onScroll">
    <!-- 头部导航 -->
    <div class="shareItem">
       <shareItem v-show="isShareCome || $route.query && $route.query.sharetype =='browser'" :dlurl="dlurl" pageCode="5010301" v-isNoAppShare/>
    </div>
    <!-- <van-sticky v-if="!home.componentList || home.componentList.length == 0">
      <search :brandId="formData.id" />
    </van-sticky> -->
    <!-- 店铺楼层 -->
    <div  v-for="(item,index) in home.componentList" :key="index" :class="'floor'+item.pageType" > 
      <div v-if="item.pageType === 19" class="index" :style="{backgroundColor:item.pageType == 19  ? item.bgColor:'',backgroundImage:`url(${ item.pageType == 19 ? item.bgImageUrl :''})`,}">
        <div :style="{background:item.style2 == 2 ? 'rgba(0, 0, 0, 0.3)':'' }" >
          <van-sticky ><searchome :brandId="getId" :item="item" :ishder="isHder "/></van-sticky>
        </div> 
        <brandHeader :formData="formData" :floor="item" :home="home" :isSelect="isSelect"  @changeData="changeData" @offsetHeight="offsetHeight"  @call="onCall" />
      </div>
      <div v-if="item.pageType == 21 && branchStatus != 'PREPARE' && isSelect !=2"  class="ad-images-box">
        <AdImages v-if="item.pageType === 21" :floor="item" :home="home"  @call="onCall"/>
      </div>
    </div>
    <div v-if="branchStatus == 'PREPARE'" class="Empty">
      <img src="@/assets/store-null.png" alt="">
      <div class="tip">店铺正在准备中，敬请期待</div>
    </div>
    <div v-else>
      <List :filterOffsetTop="filterOffsetTop" :branchid="getId" :goodsActivityInfo="formData.goodsActivityInfo" :styleStoreType="true" v-if="isSelect == 1"></List>
      <!-- 首页部分 -->
      <brand-home :home="home"  v-if="isSelect == 0"></brand-home>
      <!-- 分类部分 -->
      <div v-if="isSelect == 2 && branchStatus != 'PREPARE'" class="classification" :style="height">
        <brand-class ></brand-class>
      </div>
    </div>
    
    <div class="footer">
      <!-- 线上线下同步售卖，查看更多商品请
      <button @click="contactBee">
        <img src="@/assets/brand/bottom-icon.png" alt="">
        联系蜜蜂
      </button> -->
      <brand-tab @contactBee="contactBee" @getSeleceIndex="getSeleceIndex"></brand-tab>
    </div>

    <div class="rest_tip" v-if="branchStatus == 'REST'">店铺正在休息中</div>
  </div>
</template>
<script>
import search from "./components/search";
import searchome from "./components/searchhome";
import brandHeader from "./components/brandHeader";
import copuonIndex from "./components/couponTag";
import List from "./components/list";
import http from "@/utils/axios";
import shareItem from "@/views/shareDiscovery/components/shareBtn";
import utils from "@/utils/common";
import AdSwiper from '@/components/ad/swiper'
import AdImages from '@/views/activities/floors/ad-images'
import brandTab from "./components/brand-tab.vue";
import brandHome from "./components/brand-home.vue";
import brandClass from "./components/brand-class.vue"
export default {
  data() {
    return {
      isShareCome: this.$route.query.share == "1" ? true : false,
      brandId: 0,
      dlurl: "",
      footer: true,
      formData: {},
      userInfo:{},
      gioObj: {
        entryShape_var: "店铺首页",
        entryPage_var: document.title,
        functionName_var: "联系蜜蜂",
        primarySort_var: "",
        secondSort_var: "",
        thirdSort_var: "",
        fourthSort_var: "",
        brand_var: "",
        productName_var: ""
      },
      branchStatus: '',
      home:{},
      componentList:[],
      isSelect:1,  //默认商品的
      isHder:false,
      height:0,
      brand:''
    };
  },
  beforeDestroy() {
    this.$root.$el.removeEventListener('scroll', this.onScroll)
  },
  mounted() {
     this.onScroll.bind(this)
     this.$root.$el.addEventListener('scroll', this.onScroll)
  },
  methods: {
    // 分类主页头部占据的高度
    offsetHeight(height){
      this.height = {top:(height + 50) + 'px'}
    },
    // 滚动
    onScroll(e){
     const scrollTop = this.$root.$el.scrollTop;
      if(scrollTop > 50){
        this.isHder = true
      }else{
        this.isHder = false
      }
    },
    // 回调回来刷新页面
    onCall(){
        this.getHomeContentPageData();
    },
   
    getSeleceIndex(e){
      e.index == 3 ? this.contactBee() : this.isSelect = e.index
    },
    changeData() {
      this.getBrandDetails();
    },
    getBrandDetails() {
      this.dlurl = this.$route.query.dlurl;
      let id = this.$route.query.id
        ? this.$route.query.id
        : this.$route.query.brandId;

      if (id) {
        http({
          url: "shop/user/branch/" + id,
          method: "get"
        }).then(rps => {
          if (rps.code == 200) {
            this.formData = rps.data;
            this.$loading.hide();
          }
        });
      }
    },
    contactBee() {
      let that = this
      that.$minicode.show({pageCode:'5010301',pageQueryParam:that.$route.query,isShow:'为了您有更好的体验，请您下载APP 或打开小程序'});
      utils.contactBees(that.formData.id);
      that.$publicFunc.getJumpSingeOrTeam({
        statusParmes: {
          branchId: that.formData.id
        },
        teamParmes: {
          branchId: that.formData.id
        },
        callback: function (status, teamDetail) {
          utils.beeChatGioReport({
            gio: that.gioObj,
            business: {
              branchId: that.formData.id,
              key: "easemob",
              teamChatId: status.isTeamChat && teamDetail.teamChatId ? teamDetail.teamChatId : ""
            }
          });
        }
      })
    },
    altlsFun() {
      let pames = {
        userID_var: this.userInfo.userId,
        userName_var: this.userInfo.nickname,
        functionName_var: "逛逛问问",
        storeID_var: this.formData.id,
        storeName_var: this.formData.branchName
      };
      gio("track", "shopEnterImageSet_var", pames);
      
      utils.jumpToNewPage({
        url:
          location.origin +
          "/h5user/atlasDetail?type=brand&brandId=" +
          this.formData.id,
        noTitle: "1"
      });
    },
    /**
     * 获取店铺此时的状态
     */
    getBranchStatus() {
      let id = this.$route.query.id ? this.$route.query.id : this.$route.query.brandId;
      http({
          url: "order/admin/branch/getBranchStatus",
          method: "post",
          parmes: {
            branchId: id
          }
        }).then(rps => {
          if (rps.code == 200) {
            this.branchStatus = rps.data.branchStatus
          }
        });
    },

    
    // 获取最新的接口
    getHomeContentPageData(){
       let id = this.$route.query.id
        ? this.$route.query.id
        : this.$route.query.brandId;
      http({
        method: 'post',
        url: '/order/app/new/content-page/getHomeContentPageData',
        parmes: {
          type:6,
          branchId: id,
        },
      }).then(data => {
        if(data.code === 200 && (data = data.data)) { 
          this.normalizeData(data)
        }
      })

    },
    normalizeData(data) {
      data.$options = this.$query
      data.componentList =data.componentList || [];
      data.componentList.forEach((floor, i) => {
        const row = this.rows[floor.modelStyle]
        if(row) {
          floor.$row = row.name
          floor.$rowIndex = row.v
        }
        floor.$index = i
        floor.type = floor.pageType
        floor.$style = this.styles[floor.style2]
        floor.marginTop = utils.rem2px(floor.marginTop),
        floor.marginBottom = utils.rem2px(floor.marginBottom)
        floor.source = 'brand'
        if(floor.modelFrom === 'IMAGE') {
          floor.imgSpace = floor.paddingLeft = floor.paddingRight = 20
        }
        this.invokeFloorStyle(floor)

      })
      this.home = data;
  },

    invokeFloorStyle(floor) {
      const numbers = [floor.paddingTop, floor.paddingRight, floor.paddingBottom, floor.paddingLeft]
      floor.$viewWidth = 750 - floor.paddingLeft - floor.paddingRight
      floor.$padding = numbers.map(n => utils.rem2px(n)).join(' ')
      floor.$bgImage = `url(${floor.bgImageUrl})`
    },

  },
  components: {
    search,
    brandHeader,
    copuonIndex,
    List,
    shareItem,
    AdSwiper,AdImages,brandTab,brandHome,brandClass,searchome
  },
  created() {
    
    this.getBrandDetails();
    if(localStorage.getItem('userInfo')){
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    }
    utils.nativeMethod({tm:'1000003',tp:{noTitle:"1"}});
    this.getBranchStatus();
    this.getHomeContentPageData();
  },
  computed: {
    getId() {
      return this.$route.query.id || this.$route.query.brandId || this.$route.query.storeId || this.formData.id
    },
    rows() {
      const list = {
        1: '1,row-one',
        2: '2,row-two',
        3: '3,row-three',
        8: '4,row-four',
        5: '5,row-five',
        9: '0,row-multiple', //一行多个
        4: '0,row-swipe', // 轮播
      }
      const rows = {}
      for(const i in list) {
        const [v, name] = list[i].split(',')
        rows[i] = { v: Number(v), name }
      }
      return rows
    },
    styles() {
      return {
        1: 'style-one',
        2: 'style-two',
        3: 'style-three',
        4: 'style-four',
        5: 'style-five',
        99: 'style-swiper' //轮播
      }
    },
    filterOffsetTop(){
      return this.home && this.home.componentList && this.home.componentList.length == 0 ? 0 : 100 || 0
    }
  },
};
</script>
<style lang="less" scoped>
.floor21{
  border-bottom: 10px solid #F7F7F7 ;
}
.floor21:nth-of-type(1){
   border-top: 10px solid #F7F7F7 ;
   background-color: #ED3939;
}

.index-newbrand-warp{position: relative;}
.shareItem{position: fixed;top: 0;left: 0;z-index: 999;width: 100%;}
.adimage{
  padding: 20rpx 30rpx 0 30rpx;
}
.classification{
  position: absolute;
  width: 100%;
  height: 100;
  left: 0;
}
.floor{
  z-index: 88;
}

.index {position: relative;}
.ab{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}
.index{
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-bottom: 20px;
}
.Empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  >img {
    width: 220px;
    height: 220px;
    margin-top: 194px;
  }
  .tip {
    font-size: 24px;
    color: #333;
    margin-top: 50px;
  }
}
.rest_tip {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 100px;
  z-index: 10;
  width: 100%;
  height: 80rpx;
  background: #FFE7E6;
  line-height: 80px;
  text-align: center;
  font-size: 24px;
  color: #ED3939;
  font-weight: 500;
}
.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: #fff;
  font-size: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 0;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  button {
    outline: 0;
    border: 0;
    height: 72px;
    border-radius: 40px;
    padding-left: 10px;
    padding-right: 30px;
    background-color: #F8D541;
    color: #333;
    display: flex;
    align-items: center;
    font-size: 26px;
    font-weight: bold;
    margin-left: 26px;
  }
  img {
    width: 46px;
    height: 46px;
    margin-right: 20px;
  }
}
// .footer {
//   width: 100%;
//   position: fixed;
//   bottom: 0;
//   z-index: 2;
//   background-color: #fff;
//   justify-content: center;
//   padding: 0 20px;
//   box-sizing: border-box;
//   .item {
//     position: relative;
//     padding-top: 10px;
//     .bee {
//       width: 192px;
//       object-fit: cover;
//       position: absolute;
//       right: 222px;
//       top: -10px;
//     }
//     .altls {
//       width: 172px;
//       height: 71px;
//       object-fit: cover;
//       position: absolute;
//       right: 20px;
//       top: -10px;
//     }
//   }
//   img {
//     width: 100%;
//     object-fit: cover;
//   }
// }
.share-d {
  width: 100%;
  font-size: 24px;
  height: 125px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  .s1 {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 28px;
    padding-bottom: 26px;
    .s2 {
      padding-left: 29px;
    }
    .s21 {
      display: inline-block;
    }
    .botton {
      border-radius: 0.5rem;
      color: #000;
      font-size: 0.3rem;
      width: 140px;
      height: 55px;
      line-height: 55px;
      text-align: center;
      margin: 0 10px;
      background-color: #f8d541;
      border: 1px solid #f8d541;
    }
  }
}
.ad-images-box {
  padding: 10px 20px 10px 20px;
  background-color: #fff;
}
</style>